import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';

/**
 * Texts of the SMO Lead Raporları page (`smoLead.*`). Excel exports and the
 * values stored on records stay Turkish; only on-screen texts are translated.
 */
const useSmoText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`smoLead.${key}`, vars), [t]);
  return { t, language, locale, label };
};

export default useSmoText;
